<template>
    <v-dialog
        v-model="modelValue"
        :width="1000"
        persistent
        fullscreen
    >
        <v-card>
            <div class="">
                <div class="d-flex align-center primary pl-3 pr-2">
                    <div class="flex-grow-1 sub--text">
                        Create New Warnings
                    </div>
                    <div>
                        <v-btn
                            icon
                            color="white"
                            small
                            @click="modelValue = false"
                        >
                            <v-icon small>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </div>
                <v-divider></v-divider>
                <div class="" style="overflow-x: hidden; overflow-y: hidden">

                    <div class="d-flex align-center pa-2">

                        <v-btn
                            :text="page !== 0"
                            :color="page >= 0 ? 'primary' : null"
                            @click="page >= 0 ? page = 0 : null"
                        >
                            Select Warning & employees
                        </v-btn>
                        <v-icon class="px-3" color="grey"> mdi-arrow-right</v-icon>
                        <v-btn
                            :text="page !== 1"
                            :color="page >= 1 ? 'primary' : 'grey'"
                            @click="page = Math.min(page, 1)"
                        >
                            Review
                        </v-btn>
                        <v-icon class="px-3" color="grey"> mdi-arrow-right</v-icon>
                        <v-btn
                            :text="page !== 2"
                            :color="page >= 2 ? 'primary' : 'grey'"
                            @click="page = Math.min(page, 2)"
                        >
                            Issue Warning Warrants
                        </v-btn>
                    </div>

                    <v-scroll-x-transition :hide-on-leave="true">


                        <v-card flat :key="0" v-if="page === 0">
                            <v-card-text class="py-0">
                                <v-autocomplete
                                    color="primary"
                                    dense
                                    hide-details
                                    item-text="name"
                                    item-value="id"
                                    :items="warnings"
                                    label="Select Warning"
                                    class="pt-4"
                                    v-model="warningType"
                                />
                                <v-textarea
                                    class="pt-3"
                                    label="Please paste employee clock numbers & date of offence in the format (yyyy/mm/dd) here"
                                    hide-details
                                    color="primary"
                                    v-model="rawClockNumbers"
                                    rows="5"
                                />
                                <v-switch label="Ignore if warning pending" v-model="ignorePending"></v-switch>
                            </v-card-text>
                            <v-card-actions>

                                <v-spacer/>
                                <v-btn
                                    class="pa-2"
                                    :disabled="fetchingEmployees || !rawClockNumbers || !warningType"
                                    color="primary"
                                    :loading="fetchingEmployees"
                                    @click="fetchEmployees"
                                >
                                    Next
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                        <v-card flat :key="1" v-if="page === 1">

                            <template v-if="ignorePending && openWarnings.length">
                                <v-card-title>Ignored Warrants</v-card-title>
                                <v-card-text class="pa-0" style="overflow-x: auto">
                                    <v-data-table
                                        :headers="openWarningHeaders"
                                        :items="openWarnings"
                                        :items-per-page="5"
                                        class="elevation-1"
                                        style="min-width: 1000px"
                                        dense
                                    >
                                        <template #item.existingOffences="{item}">
                                            <span
                                                :class="item.maxOffence === item.existingOffences  ? 'error--text font-weight-bold' : null">
                                                {{ item.existingOffences }}
                                            </span>
                                        </template>

                                        <template #item.action="{item}">
                                            <div class="d-flex justify-end">
                                                <v-tooltip top>
                                                    <template #activator="{on}">
                                                        <v-btn icon color="error" @click="arrSplice(openWarnings, emp => emp === item)" v-on="on">
                                                            <v-icon>mdi-delete</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    Remove from list
                                                </v-tooltip>
                                                <v-tooltip top>
                                                    <template #activator="{on}">
                                                        <v-btn icon color="green" @click="reviewEmployees.push(item); arrSplice(openWarnings, emp => emp === item)" v-on="on">
                                                            <v-icon>mdi-arrow-down</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    Move to Warrants to issue
                                                </v-tooltip>
                                            </div>
                                        </template>

                                    </v-data-table>
                                </v-card-text>
                                <v-divider></v-divider>
                            </template>

                            <v-card-title>Warrants to issue</v-card-title>
                            <v-card-text class="pa-0" style="overflow-x: auto">
                                <v-data-table
                                    :headers="reviewEmployeeHeaders"
                                    :items="reviewEmployees"
                                    :items-per-page="10"
                                    class="elevation-1"
                                    style="min-width: 1000px"
                                    dense
                                >
                                    <template #item.existingOffences="{item}">
                                            <span :class="item.maxOffence === item.existingOffences  ? 'error--text font-weight-bold' : null">
                                                {{item.existingOffences}}
                                            </span>
                                    </template>

                                    <template #item.action="{item}">
                                        <div class="d-flex justify-end" @click="arrSplice(reviewEmployees, emp => emp === item)">
                                            <v-btn icon color="error"><v-icon>mdi-delete</v-icon></v-btn>
                                        </div>
                                    </template>

                                </v-data-table>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer/>
                                <v-btn
                                    :disabled="!reviewEmployees || !reviewEmployees.length"
                                    class="pa-2"
                                    color="primary"
                                    @click="page = ++page"
                                >Next
                                </v-btn>
                            </v-card-actions>
                        </v-card>

                        <v-card flat :key="2" v-if="page === 2" class="d-flex align-center justify-center fill-height pa-5">
                            <v-card style="min-width: 500px">
                                <v-card-title>Process Warrants</v-card-title>
                                <v-card-text class="py-0">
                                    <div class="d-flex font-weight-medium py-2">
                                        <div class="flex-equal flex-grow-1">Progress</div>
                                        <div class="flex-equal flex-grow-1">{{ importResult.processed }}</div>
                                    </div>
                                    <div class="d-flex green--text font-weight-medium py-2">
                                        <div class="flex-equal flex-grow-1">Issued:</div>
                                        <div class="flex-equal flex-grow-1">{{ importResult.inserted }}</div>
                                    </div>
                                    <div class="d-flex red--text font-weight-medium py-2">
                                        <div class="flex-equal flex-grow-1">Errors:</div>
                                        <div class="flex-equal flex-grow-1">{{ importResult.errors }}</div>
                                    </div>
                                </v-card-text>
                                <v-progress-linear class="my-2" color="secondary" :value="importResult.progress"/>
                                <v-card-actions>
                                    <v-spacer/>
                                    <v-btn
                                        v-if="!importResult.ran"
                                        class="pa-2"
                                        color="primary"
                                        @click="issueWarrants()"
                                    >Issue Warrants
                                    </v-btn>
                                    <v-btn
                                        v-else
                                        :disabled="importing"
                                        :loading="importing"
                                        class="pa-2"
                                        color="primary"
                                        @click="modelValue = false"
                                    >Done
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-card>

                    </v-scroll-x-transition>


                </div>
                <!--                <div class="text-right pr-2 pt-2 pb-2">-->
                <!--                    <v-btn-->
                <!--                            @click="validateSave()"-->
                <!--                            fab-->
                <!--                            small-->
                <!--                            color="secondary"-->
                <!--                            :loading="loading"-->
                <!--                            :disabled="!changesMade || loading"-->
                <!--                    >-->
                <!--                        <v-icon v-if="!loading">mdi-content-save</v-icon>-->
                <!--                    </v-btn>-->
                <!--                </div>-->
            </div>
        </v-card>
    </v-dialog>
</template>

<script>

import {arrSplice, objectifyArr} from "@/core/codeFunctions";

function download(filename, text) {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
}

import {mapGetters} from "vuex";
import {format} from "date-fns";

export default {
    components: {},
    props: {
        value: Boolean,
    },
    data() {
        return {
            format,
            page: 0,
            warningType: null,
            importDataRaw: null,

            openWarningHeaders: [
                {value: "empCode", text: "Clock No"},
                {value: "dateOfOffence", text: "Date of offence"},
                {value: "fullName", text: "Name"},
                {value: "idNo", text: "ID\\Passport"},
                {value: "status", text: "Cur Status"},
                {value: "existingOffences", text: "Offences"},
                {value: "lastWarrant", text: "Last Warrant"},
                {value: "action", width: 60, sortable: false},
            ],

            reviewEmployeeHeaders: [
                {value: "empCode", text: "Clock No"},
                {value: "dateOfOffence", text: "Date of offence"},
                {value: "fullName", text: "Name"},
                {value: "idNo", text: "ID\\Passport"},
                {value: "status", text: "Cur Status"},
                {value: "existingOffences", text: "Existing Offences"},
                {value: "action", width: 30, sortable: false},
            ],

            importResult: {
                ran: false,
                index: 0,
                progress: 0,
                processed: 0,
                errors: 0,
                inserted: 0
            },
            importing: false,

            rawClockNumbers: null,
            ignorePending: true,
            fetchingEmployees: false,
            openWarnings: [],
            reviewEmployees: [],
        }
    },
    watch: {
        page: {
            immediate: true,
            handler(val) {
                if (val === 2)
                    this.importResult = {
                        ran: false,
                        index: 0,
                        progress: 0,
                        processed: `0 of ${this.reviewEmployees.length}`,
                        errors: 0,
                        updated: 0,
                        inserted: 0
                    }
            }
        }
    },
    methods: {
        arrSplice,

        async fetchEmployees() {
            try {
                this.fetchingEmployees = true;

                const importClocks = this.rawClockNumbers
                    .split(/\n/g)
                    .map(str => {
                        try {
                            const split = str.split(/\t/gm);
                            return {
                                empCode: split[0],
                                doo: split[1]
                            }
                        } catch (e) {
                            console.log(e)
                        }
                    })
                    .filter(val => !!val && val.empCode && val.empCode.trim() !== '' && val.doo)



                for (const clock of importClocks) {
                    if (!clock.doo || !clock.doo.match(/^\d\d\d\d\/\d\d\/\d\d$/)) {
                        return this.$snack.error('Invalid date of offence')
                    }

                }
                
                const dooRef = objectifyArr(importClocks, 'empCode')


                const {openWarnings, reviewEmployees} = await this.$newReq('POST', 'setup/warningInit', {
                    employeeCodes: Object.keys(dooRef),
                    warningId: this.warningType,
                    ignoreExisting: this.ignorePending
                })

                this.openWarnings = openWarnings
                    .map(warning => {
                        return {
                            ...warning,
                            dateOfOffence: dooRef[warning.empCode].doo
                        }
                    });

                this.reviewEmployees = reviewEmployees
                    .map(warning => {
                        return {
                            ...warning,
                            dateOfOffence: dooRef[warning.empCode].doo
                        }
                    });

                ++this.page;
            } catch (e) {
                console.log(e)
            } finally {
                this.fetchingEmployees = false
            }

        },



        async issueWarrants() {

            this.importResult.ran = true

            const vm = this
            const errors = [];
            const importItem = (item) => {
                console.log(item)
                return new Promise((resolve) => {
                    vm.$newReq('POST', `setup/issueWarrant`, {employeeId: item.empId, warningId: this.warningType, dateOfOffence: item.dateOfOffence})
                        .then((res) => {
                            vm.importResult.inserted = ++vm.importResult.inserted
                            console.log(res)
                        })
                        .catch(e => {
                            if (e.response.status === 406) {
                                errors.push(item)
                            }
                            vm.importResult.errors = ++vm.importResult.errors
                        })
                        .finally(() => {
                            vm.importResult.index = ++vm.importResult.index
                            vm.importResult.progress = Math.floor(((vm.importResult.index + 1) / vm.reviewEmployees.length) * 100)
                            vm.importResult.processed = `${vm.importResult.index} of ${vm.reviewEmployees.length}`
                            resolve(true)
                        })
                })
            }
            this.importing = true;

            for (const row of this.reviewEmployees) {
                await importItem(row)
            }

            console.log(errors)

            if (errors.length) {

                const xls = require('json-as-xlsx');
                let data = [{
                    sheet: "Import Errors",
                    columns: [
                        {value: "empCode", label: "Clock No"},
                        {value: "fullName", label: "Name"},
                        {value: "idNo", label: "ID\\Passport"},
                        {value: "status", label: "Cur Status"},
                        {value: "existingOffences", label: "Existing Offences"},
                    ],
                    content: errors.map((errLine) => {
                        return {...errLine}
                    })
                }]
                let settings = {
                    fileName: "Import Errors.xlsx",
                }

                xls(data, settings)
            }

            this.importing = false;
        }
    },
    computed: {
        ...mapGetters(['farms', 'farmsRef', "warnings"]),

        importData() {
            try {
                let rows = this.importDataRaw.split(/\n/g)
                const headers = rows.shift().split(/\t/g)
                rows = rows.reduce((rows, line) => {
                    if (!line)
                        return rows
                    try {
                        const items = line.split(/\t/g);
                        const obj = items.reduce((obj, value, index) => {
                            obj[headers[index]] = value || null;
                            return obj
                        }, {})
                        rows.push(obj);
                        return rows;
                    } catch (e) {
                        return rows
                    }
                }, []);

                console.log(rows)


                let rowValues = rows.reduce((list, obj) => {
                    try {
                        const emp = {
                            fullName: `${obj['NAME'] || ''}${obj['First names'] || ''} ${obj['SURNAME'] || ''}${obj['Surname'] || ''}`.trim(),
                            idNo: `${obj['ID NO'] || ''}${obj['PASSPORT NO'] || ''}${obj['ID number'] || ''}${obj['Passport number'] || ''}`.trim(),
                            empCode: obj['CO NO'] || obj['CO'],
                            fkFarm: this.warningType,
                            team: obj['TEAM'] || obj['Coin group'],
                            jobDesc: obj['JOB DESCRIPTION'],
                            dob: obj['BIRTH DATE'],
                            startingDate: obj['START DATE'],
                            gender: obj['M/F (GENDER)'],
                            citizenship: obj['CITIZENSHIP'],
                            exportID: obj['EXPORT ID'] || obj['Coin number 1'],
                            barcodes: []
                        }

                        if (obj['UNIQUE CODE 1'])
                            emp.barcodes.push(obj['UNIQUE CODE 1'])

                        if (obj['UNIQUE CODE 2'])
                            emp.barcodes.push(obj['UNIQUE CODE 2'])

                        if (obj['BARCODE NO 1'])
                            emp.barcodes.push(obj['BARCODE NO 1'])

                        if (obj['BARCODE NO 2'])
                            emp.barcodes.push(obj['BARCODE NO 2'])

                        list.push(emp)
                        return list
                    } catch (e) {
                        return list
                    }
                }, [])
                return rowValues
            } catch (e) {
                return 'null'
            }
        },


        modelValue: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
}
</script>

<style scoped>

</style>